module.exports = __webpack_public_path__ + "static/23-tat4-eae6e61b21c0c0eb6cbce42e6451966f.jpg";